export const onRegexValidationPhone = (phone: string) => {
  if (!phone) return '';
  const pt1 = phone.replace(/[^0-9]/g, '');
  const pt2 = pt1.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
  return pt2;
};

export const convertDateYYYYMMDDF = (date: any) => {
  const current = new Date(date);
  const year = current.getFullYear();
  const month = (current.getMonth() + 1).toString().padStart(2, '0');
  const day = current.getDate().toString().padStart(2, '0');
  const WEEKDAY = ['일', '월', '화', '수', '목', '금', '토'];
  let dow = WEEKDAY[current.getDay()];
  return `${year}/${month}/${day} (${dow})`;
};

export const convertDateYYYYMMDDFDot = (date: any) => {
  const current = new Date(date);
  const year = current.getFullYear();
  const month = (current.getMonth() + 1).toString().padStart(2, '0');
  const day = current.getDate().toString().padStart(2, '0');
  const WEEKDAY = ['일', '월', '화', '수', '목', '금', '토'];
  let dow = WEEKDAY[current.getDay()];
  return `${year}.${month}.${day} (${dow})`;
};

export const convertDateReservation = (date: any) => {
  console.log(date);

  const current = new Date(date);
  const month = (current.getMonth() + 1).toString().padStart(2, '0');
  const day = current.getDate().toString().padStart(2, '0');
  const WEEKDAY = ['일', '월', '화', '수', '목', '금', '토'];
  let dow = WEEKDAY[current.getDay()];
  const hour = current.getHours();
  return `${month}/${day} (${dow}), ${hour}:00 ~ ${hour + 2}:00 `;
};

export const convertDateReservationDot = (date: any) => {
  console.log(date);

  const current = new Date(date);
  const year = current.getFullYear();
  const month = (current.getMonth() + 1).toString().padStart(2, '0');
  const day = current.getDate().toString().padStart(2, '0');
  const WEEKDAY = ['일', '월', '화', '수', '목', '금', '토'];
  let dow = WEEKDAY[current.getDay()];
  const hour = current.getHours();
  return `${year}.${month}.${day} (${dow}), ${hour}:00 ~ ${hour + 2}:00 `;
};

export const convertDateYYYYMMDDSymbol = (date: any, symbol = '.') => {
  const current = new Date(date);
  const year = current.getFullYear();
  const month = (current.getMonth() + 1).toString().padStart(2, '0');
  const day = current.getDate().toString().padStart(2, '0');
  return `${year}${symbol}${month}${symbol}${day}`;
};

export const convertDateFullTime = (date: any): string => {
  const current = new Date(date);
  const year = current.getFullYear();
  const month = (current.getMonth() + 1).toString().padStart(2, '0');
  const day = current.getDate().toString().padStart(2, '0');
  const WEEKDAY = ['일', '월', '화', '수', '목', '금', '토'];
  let dow = WEEKDAY[current.getDay()];
  const hour = ('0' + current.getHours()).substr(-2);
  const minute = ('0' + current.getMinutes()).substr(-2);
  const seconds = ('0' + current.getSeconds()).substr(-2);
  return `${year}/${month}/${day} (${dow}), ${hour}:${minute}:${seconds}`;
};
